import { useCallback, useState } from 'react'
import { CONNECTIONS_EVENTS } from '@/events/connectionsEvents'
import usePlatformEvent from '@/events/usePlatformEvent'

/** Bumps on {@link CONNECTIONS_EVENTS.TOOLKITS_CHANGED} — use in useMemo deps for session-backed reads. */
export default function useConnectionsToolkitSyncTick() {
  const [tick, setTick] = useState(0)
  const bump = useCallback(() => setTick((n) => n + 1), [])
  usePlatformEvent(CONNECTIONS_EVENTS.TOOLKITS_CHANGED, bump)
  return tick
}
